/**
 * Papierkorb, als Pfad statt als Bild – wie Otto und der QR-Code.
 *
 * Dasselbe Zeichen für dieselbe Sache, damit „das rote Symbol nimmt etwas weg“
 * im ganzen Produkt gilt. Der Pfad stand eine Weile doppelt – in der Admin-App
 * und in der Codetabelle der Verwaltung – mit dem Vermerk, beim dritten
 * Vorkommen ein Paket daraus zu machen. Das ist geschehen.
 *
 * Keine Farbe hier: die kommt von `currentColor`, und die setzt die Stelle, an
 * der das Symbol steht.
 */
export function TrashIcon() {
  return (
    <svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true" focusable="false">
      <path
        d="M6 2h4M2.5 4h11M4.5 4l.6 9a1 1 0 0 0 1 .9h3.8a1 1 0 0 0 1-.9l.6-9M6.8 6.5v5M9.2 6.5v5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
